import { Typography } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';

type Props = {
  message: string;
};

export const NoDataMessage = ({ message }: Props) => {
  const { t } = useTranslation();
  return (
    <Typography
      variant='h6'
      sx={{
        fontSize: '0.875rem',
      }}
    >
      {t(message)}
    </Typography>
  );
};
